import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Text,
  Icon,
  VStack,
  Heading,
  Center,
} from '@chakra-ui/react';

import { ReactComponent as RedTrashIcon } from '../../../assets/icons/red-trash.svg';

export const DeleteUsersModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: (isDeleted: boolean) => void;
}) => {
  return (
    <>
      <Modal
        blockScrollOnMount={false}
        isOpen={isOpen}
        onClose={() => onClose(false)}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Center
              bg="custom_red.2"
              borderRadius="50"
              w="10"
              h="10"
              outline="solid 8px"
              outlineColor="custom_red.3"
            >
              <Icon as={RedTrashIcon} />
            </Center>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack align="start" color="custom_blue.1">
              <Heading fontSize="md" fontWeight="semibold">
                Are you sure ?
              </Heading>
              <Text fontSize="sm">
                Are you sure you want to delete these companies? This action
                cannot be undone.
              </Text>
            </VStack>
          </ModalBody>

          <ModalFooter display="flex" flexDir="column" gap="4">
            <Button
              bg="error.600"
              _hover={{ bg: 'error.600' }}
              color="white"
              w="full"
              onClick={() => onClose(true)}
            >
              Yes, Delete
            </Button>
            <Button onClick={() => onClose(false)} w="full">
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
